import css from 'styled-jsx/css';

const styles = css.global`#carros-eletricos-premio-mobilidade .bloco-titulo {
    display: flex;
    flex-direction: column;
    padding-top: 40px;
  }

  #carros-eletricos-premio-mobilidade .bloco-titulo .premio-titulo {
    color: #C00;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "SantanderHeadline";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px;
  }

  #carros-eletricos-premio-mobilidade .bloco-titulo .premio-subtitulo {
    color: var(--Black-Preto, #222);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; /* 155.556% */
  }

  #carros-eletricos-premio-mobilidade .premio-mobilidade-btn-2 {
    min-width: 330px;
    /* white-space: nowrap; */
    /* overflow: hidden; */
    /* text-overflow:unset; */
  }

  #carros-eletricos-premio-mobilidade .premio-mobilidade-btn-1 {
    min-width: 210px;
    /* white-space: nowrap; */
    /* overflow: hidden; */
    /* text-overflow:unset; */
  }

  #carros-eletricos-premio-mobilidade .premio-mobilidade-cards {
    align-items: center;
    display: flex;
    flex-direction: column;
 }

  #carros-eletricos-premio-mobilidade .premio-mobilidade-cards-titulo {
    color: var(--Black-Preto, #222);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "SantanderHeadline";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px; /* 150% */
    margin-bottom: 40px;
  }
  #carros-eletricos-premio-mobilidade .premio-mobilidade-card-container {
    flex-wrap: column;
    width: 271px;
    min-height: 273px;
    justify-content: center;
    padding: 24px 24px 24px 24px;
    border-radius: 4px;
    border: 1px solid  #CCC;
    margin-bottom: 40px;
  }
  #carros-eletricos-premio-mobilidade .premio-mobilidade-card-main {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding-bottom: 16px;
  }
  #carros-eletricos-premio-mobilidade .premio-mobilidade-card-1{
    margin: 0px 20px 0px 16px;
  }
  #carros-eletricos-premio-mobilidade .premio-mobilidade-card-colocacao {
    font-family: "SantanderHeadline";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px; /* 150% */
    font-feature-settings: 'liga' off, 'clig' off;
  }
  #carros-eletricos-premio-mobilidade .card-primeiro {
    color: #FFAB04;
  }
  #carros-eletricos-premio-mobilidade .card-segundo {
    color: #979797;
  }
  #carros-eletricos-premio-mobilidade .card-terceiro {
    color: #DB8738;
  }
  #carros-eletricos-premio-mobilidade .premio-mobilidade-card-marca {
    color: var(--Black-Preto, #222);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "SantanderHeadline";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px; /* 150% */
  }

  #carros-eletricos-premio-mobilidade .premio-mobilidade-card-local {
    color: var(--Black-Preto, #222);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "SantanderText";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 157.143% */
  }

  #carros-eletricos-premio-mobilidade .premio-mobilidade-card-detalhe {
    border-top: #CCC 1px solid;
    margin-top: 16px;
    padding-top: 16px;
    display: flex;
    justify-content: space-between;
  }

  #carros-eletricos-premio-mobilidade .premio-mobilidade-card-detalhe-text {
    color: #222;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; /* 155.556% */
  }

  .premio-mobilidade-div-btns {
    width: 100%;
    margin: 40px 0px 40px 0px;
    overflow-x: scroll;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 10px;
    margin-bottom: 34px;
  }

  .premio-mobilidade-btn {
    font-family: 'SantanderText';
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    letter-spacing: 0px;
    text-align: center;
    color: #222222;
    width: 120px;
    padding-bottom: 10px;
    border-bottom: 1px solid #767676;
  }

  .premio-mobilidade-btn.selected {
    color: #cc0000;
    border-bottom: 2px solid #cc0000;
  }

  .premio-mobilidade-btn:hover {
    cursor: pointer;
    opacity: 0.8;
  }



  @media (min-width: 992px) {
    #carros-eletricos-premio-mobilidade .premio-mobilidade-details-div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 20px;
    }
    #carros-eletricos-premio-mobilidade .bloco-titulo {
      display: flex;
      flex-direction: row;
    }
    #carros-eletricos-premio-mobilidade .textos-titulos {
      padding-left: 65px
    }
    #carros-eletricos-premio-mobilidade .premio-mobilidade-cards {
      align-items: center;
      display: flex;
      flex-direction: row;
      justify-content: center;
      gap: 20px;
    }
    #carros-eletricos-premio-mobilidade .premio-mobilidade-cards-div-titulo {
      width: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    #carros-eletricos-premio-mobilidade .premio-mobilidade-cards-titulo {
      transform: rotate(-90deg);
      padding: 0;
      margin: 0;
    }
    /* #carros-eletricos-premio-mobilidade .card-concessionaria {
      padding-right: -80px;
    } */
    #carros-eletricos-premio-mobilidade .premio-mobilidade-card-container{
      width: 300px;
      /* height: 273px; */
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-bottom: 0;
      min-height: 310px;
    }
    #carros-eletricos-premio-mobilidade .premio-mobilidade-card-marca {
      font-size: 20px;
      line-height: 27px;
    }
    .premio-mobilidade-div-btns {
      justify-content: center;
      overflow: hidden;
    }
  }
  @media (min-width: 1200px) {
    #carros-eletricos-premio-mobilidade .premio-mobilidade-card-container{
      width: 340px;
      min-height: 280px;
    }
    /* #carros-eletricos-premio-mobilidade .premio-mobilidade-card-marca {
      font-size: 24px;
    } */
  }

  @media (min-width: 1400px) {
    #carros-eletricos-premio-mobilidade .premio-mobilidade-card-container{
      width: 356px;
    }
    #carros-eletricos-premio-mobilidade .premio-mobilidade-details-div,
    #carros-eletricos-premio-mobilidade .premio-mobilidade-cards {
      gap: 40px;
    }
    #carros-eletricos-premio-mobilidade .premio-mobilidade-card-marca {
      font-size: 23px
    }
  }`;

export default styles;